import { FC, useContext } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import classNames from 'classnames';
import { Link } from 'dibs-elements/exports/Link';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

import styles from './SbRespAppliedFiltersClearAll.scss';

type Props = {
    onClearAllClick: () => void;
};

export const SbRespAppliedFiltersClearAll: FC<Props> = ({ onClearAllClick }) => {
    const { isSbUsabilityUpdatesVariant } = useContext(ServerVarsContext);

    const className = classNames(styles.clearAllButton, {
        [styles.isSbUsabilityUpdatesVariant]: isSbUsabilityUpdatesVariant,
    });

    return (
        <Link
            buyerLinkType="standardLink"
            className={className}
            dataTn="applied-filters-clear-all"
            onClick={onClearAllClick}
        >
            <FormattedMessage
                id="sb.SbRespAppliedFiltersClearAll.button"
                defaultMessage="Clear All"
            />
        </Link>
    );
};
